module.exports = __webpack_public_path__ + "img/greengrass4.494c11f9.jpg";